require('./insuranceRequestCompilationCard.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @ utilities
const { FormattedText } = require('core/i18n').i18n;
const insuranceRequestBuildPlanItem = require('./insuranceRequestBuildPlanItem')
const insuranceRequestBuildPrimeItem = require('./insuranceRequestBuildPrimeItem')
const insuranceRequestBuildRelatedAddressItem = require('./insuranceRequestBuildRelatedAddressItem')
const insuranceRequestBuildAddressItem = require('./insuranceRequestBuildAddressItem')
const insuranceRequestBuildPaymentTypeItem = require('./insuranceRequestBuildPaymentTypeItem')
const insuranceRequestBuildContinentContentItem = require('./insuranceRequestBuildContinentContentItem')

// @ commons
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

class InsuranceRequestCompilationCard extends React.Component {

    buildList(isRelated) {
        const {
            hasSimulation,
            hasSimulationChanged,
            immInsuranceState,
            immInsuranceWizardState,
            isRnc,
            preAppraisalNotificationFlag,
        } = this.props
        const isFromSummary = false;
        let list = [
            insuranceRequestBuildPrimeItem(immInsuranceState, immInsuranceWizardState, hasSimulation, hasSimulationChanged, isFromSummary, isRnc),
            insuranceRequestBuildPaymentTypeItem(immInsuranceState, immInsuranceWizardState, hasSimulation, hasSimulationChanged, false, isRnc),
            insuranceRequestBuildContinentContentItem('continent', 'summaryContinent', immInsuranceWizardState),
            insuranceRequestBuildContinentContentItem('content', 'summaryContent', immInsuranceWizardState, isRelated, hasSimulationChanged),
            insuranceRequestBuildPlanItem(immInsuranceState, hasSimulation, hasSimulationChanged, immInsuranceWizardState),
            isRelated ? insuranceRequestBuildRelatedAddressItem(immInsuranceState, immInsuranceWizardState, preAppraisalNotificationFlag) : insuranceRequestBuildAddressItem(immInsuranceWizardState)
        ];

        const listComponent = list.map((item, index) => {
            const listElementClass = classnames(
                'insurance-request-compilation-card__list-item',
                item.className
            );

            return (
                <OKInformativeListItem
                    bodyText={item.text}
                    className={listElementClass}
                    icon={item.icon}
                    iconCustomClass={item.iconCustomClass}
                    information={item.information}
                    key={index}
                    title={item.label}
                    tooltipClassName={item.tooltipClassName}
                    tooltipOffset={item.tooltipOffset}
                    tooltipPlacement={item.tooltipPlacement}
                    bodyWordBreak={false}
                    compact
                />
            );
        });

        return (
            <OKInformativeList>
                {listComponent}
            </OKInformativeList>
        );
    }

    render() {
        const { isRelated } = this.props;

        const sectionClass = classnames('insurance-request-compilation-card', {
            'insurance-request-compilation-card--related': isRelated,
            'insurance-request-compilation-card--related-cc': __CONTACT_CENTER__
        });

        return (
            <OKSectionBox className={sectionClass}>
                <div className="insurance-request-compilation-card__header">
                    <FormattedText value="insuranceRequestHome-summaryTitle" />
                </div>
                <div>
                    {this.buildList(isRelated)}
                </div>
            </OKSectionBox>
        );
    }
}

InsuranceRequestCompilationCard.propTypes = {
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizardState: PropTypes.object.isRequired,
    hasSimulation: PropTypes.bool.isRequired,
    hasSimulationChanged: PropTypes.bool.isRequired,
    isRelated: PropTypes.bool,
    isRnc: PropTypes.bool.isRequired,
    preAppraisalNotificationFlag: PropTypes.bool,
};

InsuranceRequestCompilationCard.defaultProps = {
    isRelated: false,
    isRnc: false
};

module.exports = InsuranceRequestCompilationCard;
